<header class="floating-header">
  <div class="floating-inner px-16 py-2">

    <nav class="navbar navbar-expand-lg align-items-center">

      <!-- Logo + Name -->
      <div class="d-flex align-items-center gap-2 navbar-brand app-logo my-1">
        <a href="#" class="logo-link">
          <!-- You can update this image path when you have the new logo -->
          <img src="assets/images/rita_logo.png" alt="Nova Point" class="logo-img">
          <span class="app-title">Nova Point</span>
        </a>
      </div>

      <!-- Always visible toolbar -->
      <div class="ms-auto d-flex align-items-center">
        <app-main-toolbar></app-main-toolbar>
      </div>

    </nav>

  </div>
</header>
